module.exports = __webpack_public_path__ + "static/media/21_FVCON_KiSS.c95b51fa.png";